<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_x"></a>
<a id="page_xi"></a>
<div style="text-align: center;">
<p class="titimg"><img alt="images" src="images/74027_contt_pxi_t2.jpg"/></p>
</div>
<p class="conts"><a href="#/xhtml/Power"><i>Note from Wendy: The Power of Impact</i></a></p>
<p class="cont"><a href="#/xhtml/Preface"><i>Preface: Now is the Time</i></a></p>
<p class="cont1"><a href="#/xhtml/introduction"><i>Introduction: How to Get the Most From This Book</i></a></p>
<p class="cont2"><span href="#/xhtml/Chapter1" title="Link target outside of Sample">Chapter 1: The Multimillion-Dollar Mindset</span></p>
<p class="cont2"><span href="#/xhtml/Chapter2" title="Link target outside of Sample">Chapter 2: The Focus On Impact Business Map</span></p>
<p class="cont2"><span href="#/xhtml/Chapter3" title="Link target outside of Sample">Chapter 3: Define Your Impact Action Formula</span></p>
<p class="cont2"><span href="#/xhtml/Chapter4" title="Link target outside of Sample">Chapter 4: Discover Your Unique Gift</span></p>
<p class="cont2"><span href="#/xhtml/Chapter5" title="Link target outside of Sample">Chapter 5: Design Your Ideal Lifestyle</span></p>
<p class="cont2"><span href="#/xhtml/Chapter6" title="Link target outside of Sample">Chapter 6: Determine Your Perfect Market</span></p>
<p class="cont2"><span href="#/xhtml/Chapter7" title="Link target outside of Sample">Chapter 7: Develop One-Of-A-Kind Products and Services</span></p>
<p class="cont2"><span href="#/xhtml/Chapter8" title="Link target outside of Sample">Chapter 8: Differentiate with Impact-Driven Marketing</span></p>
<p class="cont2"><span href="#/xhtml/Chapter9" title="Link target outside of Sample">Chapter 9: Deliver Your Impact and Move People to Action</span></p>
<p class="cont2"><span href="#/xhtml/Chapter10" title="Link target outside of Sample">Chapter 10: Diversify With Impact-Driven Collaboration</span></p>
<p class="cont2"><span href="#/xhtml/Chapter11" title="Link target outside of Sample">Chapter 11: Decide Which Advice is Best for You</span></p>
<p class="cont2"><span href="#/xhtml/Chapter12" title="Link target outside of Sample">Chapter 12: Dare to Go Bigger</span></p>
<p class="cont2"><span href="#/xhtml/Chapter13" title="Link target outside of Sample">Chapter 13: Action!</span></p>
<p class="cont1"><span href="#/xhtml/Chapter14" title="Link target outside of Sample">Chapter 14: More <i>Focus On Impact</i> Success Stories</span></p>
<p class="cont2"><a id="page_xii"></a><span href="#/xhtml/Backmatter" title="Link target outside of Sample"><i>Lessons, Gifts and Gratitude</i></span></p>
<p class="cont2"><span href="#/xhtml/Backmatter1" title="Link target outside of Sample"><i>More Praise for Focus On Impact</i></span></p>
<p class="cont2"><span href="#/xhtml/Backmatter2" title="Link target outside of Sample"><i>Meet Wendy</i></span></p>
<p class="cont2"><span href="#/xhtml/Backmatter3" title="Link target outside of Sample"><i>Join Wendy Live and Online</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?588f9744